<template>
    <div>
        <div v-if="item.organisation" class="row">
            <span class="row-label">Организация:</span>
            <span class="row-value">{{ item.organisation }}</span>
        </div>
        <div v-if="item.position" class="row">
            <span class="row-label">Должность:</span>
            <span class="row-value">{{ item.position }}</span>
        </div>
        <div v-if="item.region" class="row">
            <span class="row-label">Город:</span>
            <span class="row-value">{{ item.region.value }}</span>
        </div>
        <div v-if="period" class="row">
            <span class="row-label">Период работы:</span>
            <span class="row-value">{{ period }}</span>
        </div>
        <div v-if="item.website" class="row">
            <span class="row-label">Сайт работодателя:</span>
            <a
                :href="item.website"
                class="row-link"
                target="_blank"
            >
                {{ item.website }}
            </a>
        </div>
         <div v-if="positionLevel" class="row">
            <span class="row-label">Уровень должности:</span>
            <span class="row-value">{{ positionLevel }}</span>
        </div>
         <div v-if="workersNumber" class="row">
            <span class="row-label">Количество сотрудников в организации:</span>
            <span class="row-value">{{ workersNumber }}</span>
        </div>
        <div v-if="item.responsibilities" class="row">
            <span class="row-label">Обязанности:</span>
            <span class="row-value">{{ item.responsibilities }}</span>
        </div>
    </div>
</template>

<script>
import {getFormattedDate} from "@/tools/moment-date";

import { mapGetters } from "vuex";

const getters = ['dictionaryByType'];

export default {
    name: "ParticipantCareerBlock",

    props: {
        item: {
            type: Object,
            default: () => {
            },
        },
    },

    computed: {
        ...mapGetters(getters),
        
        period() {
            if (this.item && this.item.dateStart) {
                const start = this.item.dateStart ? getFormattedDate(this.item.dateStart, 'MMMM YYYY г.') : '';
                const isNow = this.item.isUntilNow;
                let end = '';
                if (isNow) {
                    end = 'по настоящее время';
                } else {
                    end = this.item.dateEnd ? getFormattedDate(this.item.dateEnd, 'MMMM YYYY г.') : '';
                }

                return `${ start } ${ isNow ? end : `- ${ end }` }`;
            }
            return '';
        },

        positionLevel() {
            const levelList = this.dictionaryByType('position_level');
            const v = levelList && this.item ? levelList.find(el => String(el.id) === String(this.item.foreignPositionLevelId)) : null;
            return v && this.getLowerCase(v.field_value);
        },

        workersNumber() {
            const levelList = this.dictionaryByType('workers_number');
            const v = levelList && this.item ? levelList.find(el => String(el.id) === String(this.item.foreignWorkersNumberId)) : null;
            return v && this.getLowerCase(v.field_value);
        },
    },

    methods: {
        getLowerCase(value) {
            return value ? value.toLowerCase() : '';
        },
    },
};
</script>

<style scoped>

</style>